import { render, staticRenderFns } from "./TourAdjustFee.vue?vue&type=template&id=10438f52"
import script from "./TourAdjustFee.vue?vue&type=script&lang=js"
export * from "./TourAdjustFee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports